import { VStack } from '@chakra-ui/react';
import { AccordionRoot } from '@/components/ui/accordion';
import { ReactNode } from 'react';

export default function NavbarRoot({ children, isOpen }: { children: ReactNode; isOpen: boolean }) {
  return (
    <VStack
      height="100%"
      bg="navBG"
      padding={{
        base: '2',
        md: '4',
      }}
      alignContent="space-between"
      maxWidth={400}
      width={isOpen ? 300 : 'auto'}
    >
      <AccordionRoot
        collapsible={true}
        multiple={true}
        display="flex"
        flexDirection="column"
        width="100%"
        height="100%"
        gap={2}
      >
        {children}
      </AccordionRoot>
    </VStack>
  );
}
